// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3w-_x","footer":"ModalInfo_footer__28e5-"};